import React from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IconFont } from "../../../../icon-font/iconfont";
import { color } from "../../../../mui-theme/palette";
import { textStyleSet } from "../../../../mui-theme/text.style";
import { ROOT_PATH } from "../../../../routes/constants";

/**
 * KASH Assessment Completion Screen
 *
 * This component displays the completion status after a successful assessment submission.
 */
export const KashAssessmentCompleteScreen: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { assignmentId } = useParams<{ assignmentId: string }>();
  const location = useLocation();

  // Get completion data from navigation state
  const state = location.state as {
    submittedAt?: string;
    insightsAvailable?: boolean;
  } | null;

  const handleGoBack = () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          action: "VIEW_INSIGHTS",
        }),
      );
    }
    setTimeout(() => {
      navigate(-1);
    }, 1000);
  };

  const handleViewInsights = () => {
    // TODO: Navigate to insights/results page when implemented
    navigate(`${ROOT_PATH}/mdrt/kash-assessment-quiz/${assignmentId}/insights`);
  };

  return (
    <div className="flex flex-col flex-1 items-center justify-center w-full p-12">
      <IconFont name="radio_selected" size={52} color={color.green} />

      <p style={textStyleSet.text_18_bold} className="py-4 text-center">
        {t("Incentive.thank_you_submission")}
      </p>

      <p style={textStyleSet.text_14_reg} className="text-grey99 text-center">
        {t("Incentive.view_insights_message")}
      </p>

      <button
        onClick={handleGoBack}
        className="py-3 px-4 mt-6 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-75 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {t("Incentive.view_results")}
      </button>
    </div>
  );
};
